<div class="header">
  <div class="logo-container">
    <img routerLink="/dashboard" class="logo-img" src="./assets/images/Logo.svg" alt="logo">
    <h2 class="logo-text">Medpad</h2>
  </div>
  <div class="links-container" *ngIf="!isUserAuthenticated">
    <a mat-flat-button href="https://play.google.com/store/apps/details?id=com.hust.medpad" target="_blank">Download App</a>
    <button mat-flat-button class="sign-in" (click)="openSignInDialog()">SIGN IN</button>
  </div>
  <div class="links-container" *ngIf="isUserAuthenticated">
    <a mat-flat-button href="https://play.google.com/store/apps/details?id=com.hust.medpad" target="_blank">Download App</a>
    <button mat-stroked-button class="logout" (click)="logout()">LOGOUT</button>
  </div>
</div>
